var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var ReviewerFormView = Marionette.View.extend({
    template: require('../../templates/review/reviewer-form.html'),

    regions: {
        persons: '#persons',
        organizations: '#organizations'
    },

    ui: {
        persons: '#persons',
        organizations: '#organizations',
        mandatory: '#mandatory'
    },

    events: {
        'click .remove-reviewer': 'removeReviewer',
        'click #mandatory': 'mandatoryChanged'
    },

    childViewEvents: {
        'suggestor:selected:person': 'personChanged',
        'suggestor:selected:organization': 'organizationChanged'
    },

    constants: {
        maxNumberOfItemsInControlWithSuggester: 20
    },

    templateContext: function () {
        var that = this;
        return {
            showRemove: this.showRemove,
            mandatory: this.reviewer.mandatory ? 'checked' : '',
            removeButtonText: this.obsoleteInsteadOfRemove ? (this.reviewer.status == 'DELETED' ? "Undo obsolete" : "Obsolete reviewer") : "Remove reviewer",
            status: this.reviewer.status
        }
    },


    initialize: function (options) {
        //_.bindAll(this, 'personChanged', 'organizationChanged', 'removeReviewer', 'mandatoryChanged', 'disableInputsByConf');

        this.reviewer = options.reviewer;
        this.regionId = options.regionId;
        this.getReviewerName = options.getReviewerName;

        if (typeof options.obsoleteInsteadOfRemove === "undefined") {
            this.obsoleteInsteadOfRemove = false;
        } else {
            this.obsoleteInsteadOfRemove = options.obsoleteInsteadOfRemove;
        }

        this.initDisabled();

        if (!_.isUndefined(options.showRemove)) {
            this.showRemove = options.showRemove;
        }
    }
    ,

    onRender: function () {
        var that = this;

        that.showChildView('organizations', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Organization",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'organization',
            defaultSelected: that.getReviewerName && _.isFunction(that.getReviewerName) && that.reviewer.organizationId ? {
                id: that.reviewer.organizationId,
                name: that.getReviewerName(that.reviewer.organizationId)
            } : null
        }));

        that.showChildView('persons', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isMd;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Person",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'person',
            defaultSelected: that.getReviewerName && _.isFunction(that.getReviewerName) && that.reviewer.personId ? {
                id: that.reviewer.personId,
                name: that.getReviewerName(that.reviewer.personId)
            } : null
        }));

        window.setTimeout(function () {
            that.disableInputsByConf();
        }, 0);
    },

    initDisabled: function () {

        if (this.reviewer.status == 'SIGNED' || this.reviewer.status == 'VIEWED') {
            this.showRemove = false;
            this.disablePersonSelect = true;
            this.disableMandatory = true;
        } else if (this.reviewer.status == 'DELETED') {
            this.showRemove = true;
            this.disableOrganizationSelect = true;
            this.disablePersonSelect = true;
            this.disableMandatory = true;
        } else {
            this.showRemove = true;
            this.disablePersonSelect = false;
            this.disableOrganizationSelect = false;
            this.disableMandatory = false;
        }
    },

    disableInputsByConf: function () {
        if (this.disablePersonSelect) {
            this.ui.persons.find('input').each(function () {
                $(this).attr('disabled', true);
            });
        }

        if (this.disableOrganizationSelect) {
            this.ui.organizations.find('input').each(function () {
                $(this).attr('disabled', true);
            });
        }

        if (this.disableMandatory) {
            this.ui.mandatory.attr('disabled', true);
        }
    },

    organizationChanged: function (id) {
        this.reviewer.organizationId = id;
        this.triggerMethod('reviewer:changed');
    },

    personChanged: function (id) {
        this.reviewer.personId = id;
        this.triggerMethod('reviewer:changed');
    },

    mandatoryChanged: function (event) {
        this.reviewer.mandatory = event.target.checked;
    },

    removeReviewer: function () {
        var that = this;
        if (that.showRemove)
            if (that.obsoleteInsteadOfRemove) {
                if (that.reviewer.status == 'UNREVIEWED')
                    that.reviewer.status = "DELETED";
                else
                    that.reviewer.status = "UNREVIEWED";

                that.initDisabled();
                that.triggerMethod('reviewer:re-render', that.regionId);
            }
            else
                that.triggerMethod('reviewer:will-be-remove', {regionId: that.regionId, reviewer: that.reviewer});
    }
});

module.exports = ReviewerFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/review/reviewer-form-view.js
// module id = 315
// module chunks = 0